export const orderRegExp = /^((mp|мр)\d{7,7}|\d{12,12})$/i;
export const phoneRegExp = /^((8|\+7|7)[- ]?)\(?\d{3}\)?[- ]?(\d[- ]?){7}$/;
